import {
  CaseTypeEnum as ECaseType,
  CrossbitePresentEnum as ECrossbitePresent,
  DentitionTypeEnum as EDentitionType,
  GingivalContoursEnum as EGingivalContours,
  GingivalDisplayAtSmileEnum as EGingivalDisplayAtSmile,
  CanineClassificationEnum as ECanineClassification,
  MolarClassificationEnum as EMolarClassification,
  CrowdingEnum as ECrowding,
  MandibularPlaneAngleEnum as EMandibularPlaneAngle,
  MidlineEnum as EMidline,
  OverjetEnum as EOverjet,
  RadiographicFindingsEnum as ERadiographicFindings,
  SkeletalClassEnum as ESkeletalClass,
  SmileArcEnum as ESmileArc,
  TmjEnum as ETMJ,
  UpperSpacingEnum as EUpperSpacing,
  UpperCentralIncisorPositionEnum as EUpperCentralIncisorPosition,
  OverbiteEnum as EOverbite,
  ToothSizeDiscrepanciesEnum as EToothSizeDiscrepancies,
} from "@/api/generated/patient/orthoProposedPlan.types";
import { CrowdingEnum as ELowerSpacing } from "@/api/generated/patient/orthoProposedPlan.types";

export {
  ECaseType,
  ECrossbitePresent,
  EDentitionType,
  EGingivalContours,
  EGingivalDisplayAtSmile,
  ECanineClassification,
  EMolarClassification,
  ECrowding,
  EMandibularPlaneAngle,
  EMidline,
  EOverjet,
  ERadiographicFindings,
  ESkeletalClass,
  ESmileArc,
  ETMJ,
  EUpperSpacing,
  EUpperCentralIncisorPosition,
  EOverbite,
  EToothSizeDiscrepancies,
  ELowerSpacing,
};

export interface TOrthoProposedPlan {
  id: string;
  skeletal_class: ESkeletalClass;
  radiographic_findings: ERadiographicFindings[];
  right_molar_classification: EMolarClassification;
  left_molar_classification: EMolarClassification;
  midline: EMidline;
  overbite: EOverbite;
  overjet: EOverjet;
  crossbite_present: ECrossbitePresent;
  upper_spacing: EUpperSpacing;
  lower_spacing: ELowerSpacing;
  upper_crowding: ECrowding;
  lower_crowding: ECrowding;
  tooth_size_discrepancies: EToothSizeDiscrepancies;

  mandibular_plane_angle?: EMandibularPlaneAngle;
  right_canine_classification?: ECanineClassification;
  left_canine_classification?: ECanineClassification;
  treat_the_adult_posterior_crossbite?: boolean;
  upper_central_incisor_position?: EUpperCentralIncisorPosition;
  gingival_display_at_smile?: EGingivalDisplayAtSmile;
  gingival_contours?: EGingivalContours;
  smile_arc?: ESmileArc;
  case_type: ECaseType;
  treatment_time: string;
  notes: string | null;
  confirmed_at: string;
  signed_at: string;
  patient: string;
  pricing_option: string;
  patient_treatment_plan: string;
  staff_created_by: string;
}
// if modified, update tests/patientFlow/types.ts
// export enum ESkeletalClass {
//   CLASS_I = "class_i",
//   CLASS_II = "class_ii",
//   CLASS_III = "class_iii",
//   NO_XRAY = "no_xray",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EDentitionType {
//   PRIMARY = "primary",
//   EARLY_MIXED = "early_mixed",
//   LATE_MIXED = "late_mixed",
//   PERMANENT = "permanent",
// }

// export enum ECaseType {
//   LIMITED = "limited",
//   MILD = "mild",
//   MODERATE = "moderate",
//   COMPREHENSIVE = "comprehensive",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ERadiographicFindings {
//   NORMAL = "normal",
//   MISSING_TEETH = "missing_teeth",
//   CARIES_SUSPECTED = "caries_suspected",
//   UNUSUAL = "unusual",
//   TAPERED_ROOT_SHAPE = "tapered_root_shape",
//   IMPACTED = "impacted",
//   ECTOPIC_ERUPTION = "ectopic_eruption",
//   IMPACTED_THIRD_MOLARS = "impacted_third_molars",
//   OTHER = "other",
//   NO_XRAY = "no_xray",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ETMJ {
//   ASYMPTOMATIC = "asymptomatic",
//   HISTORY_OF_TRAUMA = "history_of_trauma",
//   CLICKING_RIGHT = "clicking_right",
//   CLICKING_LEFT = "clicking_left",
//   PAIN_RIGHT = "pain_right",
//   PAIN_LEFT = "pain_left",
//   LIMITED_OPENING = "limited_opening",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EMolarClassification {
//   CLASS_I = "class_i",
//   CLASS_II = "class_ii",
//   CLASS_III = "class_iii",
//   UNERUPTED = "unerupted",
//   MISSING = "missing",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EMidline {
//   COINCIDENT_WITH_FACE = "coincident_with_face",
//   U_TO_R = "u_to_r",
//   U_TO_L = "u_to_l",
//   L_TO_R = "l_to_r",
//   L_TO_L = "l_to_l",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EOverbite {
//   MINIMAL = "minimal",
//   NORMAL = "normal",
//   MODERATE = "moderate",
//   SEVERE = "severe",
//   END_TO_END = "end_to_end",
//   OPENBITE = "openbite",
//   OPENBITE_TENDENCY = "openbite_tendency",
//   IMPINGING = "impinging",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EOverjet {
//   NORMAL = "normal",
//   MINIMAL = "minimal",
//   MODERATE = "moderate",
//   SEVERE = "severe",
//   END_TO_END = "end_to_end",
//   NEGATIVE = "negative",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ECrossbitePresent {
//   NONE = "none",
//   POSTERIOR_RIGHT = "posterior_right",
//   POSTERIOR_LEFT = "posterior_left",
//   POSTERIOR_BILATERAL = "posterior_bilateral",
//   ANTERIOR = "anterior",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EUpperSpacing {
//   NONE = "none",
//   MILD = "mild",
//   MODERATE = "moderate",
//   SEVERE = "severe",
//   MIDLINE_DIASTEMA = "midline_diastema",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ELowerSpacing {
//   NONE = "none",
//   MILD = "mild",
//   MODERATE = "moderate",
//   SEVERE = "severe",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ECrowding {
//   NONE = "none",
//   MILD = "mild",
//   MODERATE = "moderate",
//   SEVERE = "severe",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EToothSizeDiscrepancies {
//   NOT_APPARENT = "not_apparent",
//   LOWER_THAN_1_5 = "lower_than_1_5",
//   HIGHER_THAN_1_5 = "higher_than_1_5",
//   OTHER = "other",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EMandibularPlaneAngle {
//   NORMAL = "normal",
//   HIGH = "high",
//   LOW = "low",
//   NO_XRAY = "no_xray",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ECanineClassification {
//   I_MILD = "i_mild",
//   II_FULL_STEP = "ii_full_step",
//   II_MILD = "ii_mild",
//   III_MILD = "iii_mild",
//   III_FULL_STEP = "iii_full_step",
//   UNERUPTED = "unerupted",
//   MISSING = "missing",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EUpperCentralIncisorPosition {
//   UPRIGHT = "upright",
//   RETROCLINED = "retroclined",
//   PROCLINED = "proclined",
//   NO_XRAY = "no_xray",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EGingivalDisplayAtSmile {
//   ACCEPTABLE = "acceptable",
//   EXCESSIVE = "excessive",
//   LIMITED = "limited",
//   ASYMMETRIC = "asymmetric",
//   NO_RECORD = "no_record",
// }

// if modified, update tests/patientFlow/types.ts
// export enum EGingivalContours {
//   ACCEPTABLE = "acceptable",
//   HYPERTROPHIC = "hypertrophic",
//   ASYMMETRIC = "asymmetric",
//   NO_RECORD = "no_record",
// }

// if modified, update tests/patientFlow/types.ts
// export enum ESmileArc {
//   ACCEPTABLE = "acceptable",
//   FLAT = "flat",
//   REVERSED = "reversed",
//   ASYMMETRIC = "asymmetric",
//   NO_RECORD = "no_record",
// }

export interface TOrthoProposedPlanPricingOption {
  id: string;
  name: string;
  price: number;
  text: string;
  created_at: Date;
}

export enum TOrthoProposedPlanMarkType {
  CONFIRM = "confirm",
  SIGNED = "signed",
}
